import React from 'react'
import { useSessionContext } from 'components/sessions/sessionContext'
import { getPlayers, getStartedGame } from './playGameModel'
export const PlayGameContext = React.createContext()

/**
 * Exposes a context containing:
 * - game: basic game information without current turn and hands
 * - startedGame: game information along with current turn and hands
 */

export function PlayGameContextProvider(props) {
  const [game, setGame] = React.useState(props?.value?.game)
  // Current user
  const { session } = useSessionContext()

  if (!game || !session)
    return <PlayGameContext.Provider {...props} value={{ setGame }} />

  if (['created'].includes(game.status))
    return <PlayGameContext.Provider {...props} value={{ game, setGame }} />

  const homeUser = game.players.find((itm) => itm.userId === session.user.id)
    .user.id
  const players = getPlayers({ game, homeUser })

  // TODO: Destructure game and startedGame so it errors here
  const value = {
    game,
    setGame,
    startedGame: getStartedGame(game, players),
  }

  return <PlayGameContext.Provider {...props} value={value} />
}

export const usePlayGameContext = () => React.useContext(PlayGameContext)
